import { SwipeAction } from "antd-mobile"
import styled from "styled-components"

export const StyledMealItem = styled.div<{ $isFutureScheduleMeal?: boolean }>`
  display: flex;
  padding: var(--spacing_s, 8px) var(--spacing_m, 12px);
  gap: var(--spacing_s, 8px);
  align-self: stretch;
  border-radius: var(--spacing_s, 8px);
  background: #fbfbfb;
  overflow: hidden;
  ${(props) =>
    props.$isFutureScheduleMeal &&
    `border: 0.5px solid var(--Schemes-Outline-Outline-Variant, rgba(0, 38, 58, 0.14));`}
  align-items: flex-start;

  ${(props) =>
    props.$isFutureScheduleMeal &&
    `@supports (-webkit-touch-callout: none) {
    border: 1px solid var(--Schemes-Outline, rgba(0, 38, 58, 0.32));
  }`}
`

export const MealContent = styled.div<{ $isFutureScheduleMeal?: boolean }>`
  --right-calorie-box-width: 50px;
  --schedule-icon-width: 18px;
  --schedule-icon-margin-right: 4px;

  height: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: ${(props) =>
    props.$isFutureScheduleMeal
      ? "calc(100% - var(--right-calorie-box-width) - var(--schedule-icon-width) - var(--schedule-icon-margin-right))"
      : "calc(100% - var(--right-calorie-box-width))"};
`
export const MealNameBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--spacing_xs, 6px);
  height: 100%;
`

export const MealName = styled.div<{ $isFutureScheduleMeal?: boolean }>`
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 17px;
  color: ${(props) =>
    props.$isFutureScheduleMeal
      ? "var(--Schemes-On-Surface-Variant-2, #69757D)"
      : "var(--Schemes-On-Surface, #1C1F21)"};
`

export const MealCalorie = styled.div<{ $isFutureScheduleMeal?: boolean }>`
  padding: var(--spacing_xs, 5px) 0px;
  color: var(--Schemes-On-Surface-Variant-2, #69757d);
  font-weight: 500;
  flex-shrink: 0;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  opacity: ${(props) => (props.$isFutureScheduleMeal ? 0.8 : 1)};
`

export const StyledSwipeAction = styled(SwipeAction)`
  --adm-color-danger: #ff4921;
  cursor: default;
  border-radius: var(--spacing_s, 8px);
  border: 0.5px solid
    var(--Schemes-Outline-Outline-Variant, rgba(0, 38, 58, 0.14));

  @supports (-webkit-touch-callout: none) {
    border: 1px solid var(--Schemes-Outline, rgba(0, 38, 58, 0.32));
  }

  background: #fbfbfb;
  overflow: hidden;

  .adm-swipe-action-actions-right .adm-button {
    width: 64px;
  }

  span {
    display: flex;
  }
`

export const MealTypeTag = styled.div`
  color: var(--Schemes-Brand-color-Primary, #0da3ba);
  font-size: 12px;
  font-weight: 500;

  border-radius: 2px;
  background: rgba(13, 163, 186, 0.12);
  padding: 0px 4px;
  text-transform: capitalize;
  height: 15px;
  line-height: 15px;
`

export const MealUnitAndPortionBox = styled.div`
  display: flex;
  align-items: center;
  color: var(--Schemes-Surface-On-surface-On-Surface-Variant-2, #69757d);
`

export const MealUnitAndPortionText = styled.p`
  font-size: 12px;
  font-weight: 500;
  height: 15px;
  line-height: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
